import axios from 'axios';

export default axios.create({
  baseURL: 'https://eqrx.egnyte.com/pubapi/v1/fs-content/Shared/Dice',
  headers: {
    'Content-Type': 'undefined',
    Accept: '*/*',
    Authorization: 'Bearer ca6jq5qkb2awgrrujbgc2hs8',
  },
});
